import ProductList from "@/vue/as/ProductList.vue";
import { mountVue } from "@/vue";

mountVue({
    components: {
        'as-product-list': ProductList,
    }
});
